import React from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { setPageMeta } from "utils/seo.js";

class IoTPlatform extends React.Component {
  componentDidMount() {
    setPageMeta({
      title: "IoT Platform",
      description:
        "The Chisp Hub and dashboard: connected sensors and cameras with AI-powered monitoring, real-time alerting, and unified device management across industrial sites and homes.",
      path: "/platform",
    });
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <div className="position-relative">
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-chisp-platform">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="10" className="mx-auto text-center">
                      <h1 className="display-3 text-white">
                        IoT Platform{" "}
                        <span>&amp; Devices</span>
                      </h1>
                      <p className="lead text-white">
                        Our own hardware and software: connected sensors and cameras
                        reporting into one hub, with AI-powered monitoring, real-time
                        alerting, and unified device management. Deployed across
                        industrial sites, commercial spaces, and homes.
                      </p>
                    </Col>
                  </Row>
                </div>
              </Container>
            </section>
          </div>

          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4">
                      <Card className="shadow border-0 h-100">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="ni ni-button-power" />
                          </div>
                          <h5 className="text-success">The Chisp Hub</h5>
                          <p className="description mt-3">
                            One hub gathers every sensor, camera, and device on a site,
                            so you stop stitching together separate systems that do not
                            talk to each other.
                          </p>
                          <ul className="list-unstyled mt-3">
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Standard protocols and APIs
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Edge processing on site
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Ruggedized for industrial use
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="shadow border-0 h-100">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="ni ni-bell-55" />
                          </div>
                          <h5 className="text-primary">Real-Time Alerting</h5>
                          <p className="description mt-3">
                            The platform watches for the events that matter and tells
                            you the moment one happens, with AI verification to keep
                            false alarms down.
                          </p>
                          <ul className="list-unstyled mt-3">
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Human detection in hazard zones
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              PPE and compliance monitoring
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Anomaly and motion detection
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="shadow border-0 h-100">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-info rounded-circle mb-4">
                            <i className="ni ni-settings" />
                          </div>
                          <h5 className="text-info">Device Management</h5>
                          <p className="description mt-3">
                            Every connected device in one dashboard: status, health, and
                            configuration, without walking the site to check hardware.
                          </p>
                          <ul className="list-unstyled mt-3">
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Unified control across sites
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Asset tracking and utilization
                            </li>
                            <li className="py-1">
                              <i className="fa fa-check text-success mr-2" />
                              Remote configuration
                            </li>
                          </ul>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section pb-0 bg-gradient-default" style={{
            background: 'linear-gradient(135deg, #232b4d 0%, #2d365f 100%)',
            padding: '0',
            paddingTop: '2.5rem',
            paddingBottom: '2.5rem'
          }}>
            <Container>
              <Row className="align-items-center flex-column-reverse flex-md-row" style={{ minHeight: '520px', padding: '1rem 0 2rem 0' }}>
                <Col md="6" className="d-flex flex-column justify-content-center align-items-center align-items-md-start" style={{gap: '2.5rem'}}>
                  <div style={{ width: '100%', maxWidth: 520, margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h2 style={{ color: '#fff', fontSize: '2.3rem', fontWeight: 700, marginBottom: '0.5rem', letterSpacing: '-1px', lineHeight: 1.1, textAlign: 'center' }}>Chisp IoT Dashboard</h2>
                    <h5 style={{ color: '#B2B7FF', fontWeight: 400, marginBottom: '2rem', fontSize: '1.15rem', letterSpacing: '-0.5px', textAlign: 'center' }}>Real-Time Monitoring & AI-Powered Insights</h5>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', width: '100%', alignItems: 'center' }}>
                      <div className="card bg-white shadow">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-gradient-primary text-white rounded-circle mr-3">
                              <i className="ni ni-chart-bar-32" />
                            </div>
                            <div>
                              <h6 className="text-primary text-uppercase ls-1 mb-1">Real-Time Alerts</h6>
                              <p className="text-sm mb-0">
                                Instantly receive notifications for important events, such as human detection in hazard zones.<br />
                                <span className="text-primary font-weight-bold">Stay informed, stay secure</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card bg-white shadow">
                        <div className="card-body">
                          <div className="d-flex align-items-center">
                            <div className="icon icon-shape bg-gradient-warning text-white rounded-circle mr-3">
                              <i className="ni ni-settings" />
                            </div>
                            <div>
                              <h6 className="text-warning text-uppercase ls-1 mb-1">Device Management</h6>
                              <p className="text-sm mb-0">
                                <span className="font-weight-bold">Unified Control:</span> Manage all your connected devices from a single dashboard.<br />
                                <span className="font-weight-bold">AI-Powered Insights:</span> Leverage advanced analytics and AI to optimize your site's safety and efficiency.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md="6" className="d-flex justify-content-center align-items-center mb-5 mb-md-0" style={{ minHeight: 400 }}>
                  <img
                    alt="Chisp IoT Dashboard Preview"
                    src={require("assets/img/theme/Dashboard.png")}
                    style={{
                      width: "100%",
                      maxWidth: "700px",
                      height: "auto",
                      borderRadius: "1.5rem",
                      boxShadow: "0 8px 32px rgba(44,62,80,0.18)",
                      background: "rgba(255,255,255,0.01)",
                      margin: "2rem 0",
                      border: '1.5px solid rgba(255,255,255,0.18)'
                    }}
                  />
                </Col>
              </Row>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>
          <section className="section bg-white" style={{paddingTop: '2.5rem', paddingBottom: '2.5rem'}}>
            <Container>
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3">How does it work?</h2>
                  <p className="lead text-muted">
                    Every alert the platform raises goes through the same three steps.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid mt-5">
                <Col lg="4">
                <div className="pt-4 text-center">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow rounded-circle text-white mb-4">
                    <i className="ni ni-zoom-split-in" />
                  </div>
                  <h4 className="mt-3">Observe</h4>
                  <p className="text-muted mt-3">
                    Detect anomalies such as motion or unexpected activity
                  </p>
                </div>
                </Col>
                <Col lg="4">
                  <div className="pt-4 text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-success shadow rounded-circle text-white mb-4">
                      <i className="ni ni-atom" />
                    </div>
                    <h4 className="mt-3">Verify</h4>
                    <p className="text-muted mt-3">
                      Run advanced AI models to verify the anomaly and reduce false alarms
                    </p>
                  </div>
                </Col>
                <Col lg="4">
                  <div className="pt-4 text-center">
                    <div className="icon icon-lg icon-shape bg-gradient-warning shadow rounded-circle text-white mb-4">
                      <i className="ni ni-bell-55" />
                    </div>
                    <h4 className="mt-3">Act</h4>
                    <p className="text-muted mt-3">
                      Instantly notify or sound the alarm to keep your site secure
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
            {/* SVG separator */}
            <div className="separator separator-bottom separator-skew zindex-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
                version="1.1"
                viewBox="0 0 2560 100"
                x="0"
                y="0"
              >
                <polygon
                  className="fill-white"
                  points="2560 0 2560 100 0 100"
                />
              </svg>
            </div>
          </section>

          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <h2 className="display-3">Where it runs</h2>
                  <p className="lead text-muted">
                    The same platform, tuned to the environment it is deployed in.
                  </p>
                </Col>
              </Row>
              <Row className="row-grid">
                <Col lg="4">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-4 py-lg-5">
                      <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                        <i className="fa fa-industry" />
                      </div>
                      <h5 className="text-primary">Industrial Monitoring</h5>
                      <p className="description mt-3">
                        Equipment performance, environmental conditions, predictive
                        maintenance, and job site safety across factories, warehouses,
                        and work sites.
                      </p>
                      <Button
                        className="btn-round mt-3"
                        color="primary"
                        to="/industrial"
                        tag={Link}
                      >
                        Industrial Monitoring
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-4 py-lg-5">
                      <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                        <i className="fa fa-home" />
                      </div>
                      <h5 className="text-success">Home Connectivity</h5>
                      <p className="description mt-3">
                        Smart home device integration, intelligent automation, energy
                        monitoring, and security, controlled from one place.
                      </p>
                      <Button
                        className="btn-round mt-3"
                        color="success"
                        to="/home"
                        tag={Link}
                      >
                        Home Connectivity
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="4">
                  <Card className="shadow border-0 h-100">
                    <CardBody className="px-lg-4 py-lg-5">
                      <div className="icon icon-shape icon-shape-info rounded-circle mb-4">
                        <i className="fa fa-line-chart" />
                      </div>
                      <h5 className="text-info">Platform Analytics</h5>
                      <p className="description mt-3">
                        The analytics layer over your device data: real-time processing,
                        predictive modeling, and dashboards built for the people who act
                        on them.
                      </p>
                      <Button
                        className="btn-round mt-3"
                        color="info"
                        to="/data-analytics"
                        tag={Link}
                      >
                        Platform Analytics
                      </Button>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>

          <section className="section section-lg bg-gradient-default">
            <Container>
              <Row className="text-center justify-content-center">
                <Col lg="10">
                  <h2 className="display-3 text-white">Built by the people who run it</h2>
                  <p className="lead text-white">
                    We design the hardware, write the firmware, and operate the cloud
                    platform behind it. When something needs changing for your site, you
                    are asking the team that built it.
                  </p>
                </Col>
              </Row>
              <Row className="justify-content-center mt-5">
                <Col lg="8" className="text-center">
                  <Button
                    className="btn-round"
                    color="white"
                    size="lg"
                    to="/contact"
                    tag={Link}
                  >
                    Talk to us about a deployment
                  </Button>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default IoTPlatform;
